import React, { useEffect, useCallback } from 'react'

import {
  FlexContainer,
  VendorPricingAgreementTiersDisplay,
} from '@components/common'

import {
  VendorPricingAgreement,
  VendorPricingAgreementScopes,
  VendorPricingAgreementServiceTypes,
} from '@types'

interface MarketVendorPricingAgreementsProps {
  hqId: number
  vendorPricingAgreements: VendorPricingAgreement[] | null
  getMarketVendorPricingAgreements: (params: {
    hqId: number
  }) => Promise<VendorPricingAgreement[] | null>
  editVendorPricingAgreement: (
    vendorPricingAgreement: VendorPricingAgreement,
  ) => void
}

const MarketVendorPricingAgreements: React.FC<
  MarketVendorPricingAgreementsProps
> = ({
  hqId,
  vendorPricingAgreements,
  getMarketVendorPricingAgreements,
  editVendorPricingAgreement,
}) => {
  const refreshAgreement = useCallback(async () => {
    await getMarketVendorPricingAgreements({ hqId })
  }, [getMarketVendorPricingAgreements, hqId])

  useEffect(() => {
    refreshAgreement()
  }, [refreshAgreement])

  const onAddMarketVendorPricingAgreement = () => {
    editVendorPricingAgreement({
      id: '',
      scope: VendorPricingAgreementScopes.MARKET,
      serviceTypes: [
        VendorPricingAgreementServiceTypes.CATERING,
        VendorPricingAgreementServiceTypes.GROUP_ORDER,
      ],
      vendorId: null,
      hqId,
      tiers: [
        {
          position: 1,
          lowerLimit: 0,
          upperLimit: null,
          discountPercentage: 1,
        },
      ],
      active: true,
    })
  }

  if (!vendorPricingAgreements) {
    return (
      <FlexContainer
        width="100%"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <p className="mb-5 text-md mt-10">
          No market vendor pricing agreement exists.
        </p>
        <button
          className="px-3 py-3 bg-blue-500 text-white rounded-md"
          onClick={onAddMarketVendorPricingAgreement}
        >
          Create Market Vendor Pricing Agreement
        </button>
      </FlexContainer>
    )
  }

  return (
    <div>
      <VendorPricingAgreementTiersDisplay
        pricingAgreements={vendorPricingAgreements}
        title="Market Vendor Pricing Agreements"
        onCreateVendorPricingAgreement={onAddMarketVendorPricingAgreement}
        editVendorPricingAgreement={editVendorPricingAgreement}
      />
    </div>
  )
}

export default MarketVendorPricingAgreements
